import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { LocationSelectorService } from '@services/location_selector.service';
import { Route, Routes } from 'react-router-dom';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';
import { AppointmentFlowService } from 'Public_old/src/app/Views/Appointment/appointment-flow.service';
import { sharedResolution } from '../../src/shared_resolution';
import React, { Suspense } from 'react';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { UniversalConfig } from '@application/universal_config.service';
import { Root, createRoot } from 'react-dom/client';

const containerElementName = 'reactVideoCallComponent';

const AppointmentLazy = React.lazy(() => import('@routes/appointment/mod').then((module) => ({ default: module.Appointment })));

@Component({
	standalone: false,
	styleUrls: ['./css/video-call.wrapper.scss'],
	selector: 'video-call-component',
	template: `<div class="video-call-wrapper-container" #${containerElementName}></div>`,
	encapsulation: ViewEncapsulation.None,
})
export class VideoCallWrapperComponent implements OnChanges, OnDestroy, AfterViewInit, OnInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly ngZone: NgZone,
		private appointmentFlowService: AppointmentFlowService,
		private readonly router: Router,
	) {
		// Empty
	}

	ngOnInit(): void {}

	ngOnChanges(_: SimpleChanges): void {}

	ngAfterViewInit(): void {
		this.render();
	}

	ngOnDestroy() {
		this.ngZone.runOutsideAngular(() => {
			this.root?.unmount();
		});
	}

	private async render() {
		const locationSelectorService = sharedResolution.resolve(LocationSelectorService);
		const universalConfigService = sharedResolution.resolve(UniversalConfig);

		const navigateToDuplicateConnection = () => {
			this.ngZone.run(() => {
				this.router.navigateByUrl(locationSelectorService.location.route + '/error/multiconnections');
			});
		};

		const handleLeave = (messages) => {
			this.ngZone.run(() => {
				this.appointmentFlowService.setMessages(messages);
				this.appointmentFlowService.checksAfterCall();
			});
		};

		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		const split = locationSelectorService.location.route.split('/');
		split.splice(0, 1);
		const routeBase = split.join('/');

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ProgrammaticBrowserRouter basename={universalConfigService.alias} forceNewHistory>
						<Routes>
							<Route path={routeBase}>
								<Route
									path='appointment/:ticket'
									element={
										<Suspense fallback={<div>Loading...</div>}>
											<AppointmentLazy
												__TEMP__onLeave={handleLeave}
												__TEMP__navigateToDuplicateConnection={navigateToDuplicateConnection}
											/>
										</Suspense>
									}
								/>
							</Route>
						</Routes>
					</ProgrammaticBrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}
